/*
 * @version:
 * @Author: Cuidezhen
 * @Date: 2023-04-19 11:42:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-01 13:52:36
 * @company: 医视界
 * @FilePath: \village_platform\packages\platform\src\pages\editNews\index.tsx
 * @Descripttion:
 * @Edit Record:
 */
import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Select,
  Form,
  Button,
  Table,
  Input,
  Pagination,
  message,
  Space,
  Modal,
  Radio,
  Upload,
} from "antd";
import { SearchOutlined, RedoOutlined } from "@ant-design/icons";
import {
  getLevelList,
  getEditNews,
  uploadFileAll,
  addEditNews,
  delEditNews,
  queryNewsInfo,
} from "@root/common/service";
import { useNavigate } from "react-router-dom";
import type { ColumnsType } from "antd/es/table";
// import Editor from "@/components/editor"
import BraftEditor from "braft-editor";
import "braft-editor/dist/index.css";
import { postLeaveAdvertisementTimeMap } from "@root/common/utils";
import { DeleteOutlined } from "@ant-design/icons";
interface DataType {
  key: number | string;
  title: string;
  firstColumnName: string;
  secondColumnName: string;
  selfSortNum: number | string;
  baseNewsType: string;
  publishTime: string;
  removalTime: string;
  publishStatus: string;
  baseNewsRecommend: string;
  author: string;
  updateTime: string;
  topStatus: string;
}
const { Option } = Select;

function Index() {
  const columns: ColumnsType<DataType> = [
    {
      title: "新闻标题",
      dataIndex: "title",
      key: "title",
      width: 300,
      render: (_, e) => (
        <Space size="middle">
          <Button style={{ padding: "0" }} onClick={() => look(e)} type="link">
            {e.title}
          </Button>
        </Space>
      ),
    },
    {
      title: "一级栏目",
      dataIndex: "firstColumnName",
      key: "firstColumnName",
    },
    {
      title: "二级栏目",
      dataIndex: "secondColumnName",
      key: "secondColumnName",
    },
    {
      title: "新闻类型",
      dataIndex: "baseNewsType",
      key: "baseNewsType",
      render: (_, a) => (
        <>
          {(() => {
            if (a.baseNewsType == "CONTENT") {
              return "内容";
            } else if (a.baseNewsType == "LINK") {
              return "链接";
            }
          })()}
        </>
      ),
    },
    {
      title: "上架时间",
      dataIndex: "publishTime",
      key: "publishTime",
    },
    {
      title: "下架时间",
      dataIndex: "removalTime",
      key: "removalTime",
    },
    {
      title: "发布状态",
      dataIndex: "publishStatus",
      key: "publishStatus",
      render: (_, a) => (
        <>
          {(() => {
            if (a.publishStatus == "Y") {
              return "发布";
            } else {
              return "未发布";
            }
          })()}
        </>
      ),
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="middle">
          <Button style={{ padding: "0" }} onClick={() => edit(e)} type="link">
            编辑
          </Button>
          <Button style={{ padding: "0" }} onClick={() => look(e)} type="link">
            预览
          </Button>
          <Button style={{ padding: "0" }} onClick={() => del(e)} type="link">
            删除
          </Button>
        </Space>
      ),
    },
  ];

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [firstLevelList, setFirstLevelList] = useState<any>([]);
  const [secondLevelList, setSecondLevelList] = useState<any>([]);
  const [columnList, setColumnList] = useState<any>([]);
  const [Options, setOptions] = useState<any>([]);
  const [data, setData] = useState<DataType[]>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>(0);
  const [modalTitle, setModalTitle] = useState("添加新闻");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editItem, setEditItem] = useState<any>({});
  const [isContent, setIsContent] = useState(true);
  const [fileList, setFileList] = useState<any>([]);
  const [editorState, setEditorState] = useState<any>(null);
  const navigate = useNavigate();
  useEffect(() => {
    column();
    column1();
    getTableData();
    // const editor = new E('#newsEditor')
    // let editor: any = new E(editorRef.current);
    // editor.create()
  }, []);

  const getTableData = async (e: string = "", page = 1) => {
    setCurrent(page);
    const { rows, total } = await getEditNews(
      `${e}newsOperateEnum=ALL&pageNum=${page}&pageSize=10`
    );
    rows.forEach((e: any) => {
      e.key = e.id;
    });
    console.log(rows);
    setData(rows);
    setTotal(total);
  };

  const column = async () => {
    const { rows } = await getLevelList(
      `baseNewsColumnLevel=2&pageNum=1&pageSize=99`
    );
    // setColumnList(rows);
    setSecondLevelList(rows);
    return rows;
  };

  const column1 = async () => {
    const { rows } = await getLevelList(
      `baseNewsColumnLevel=1&pageNum=1&pageSize=99`
    );
    setFirstLevelList(
      rows.filter(
        (item: any) => item.name !== "首页" && item.name !== "个人中心"
      )
    );
  };

  const onFinish = useCallback((e: any) => {
    console.log(e);
    const keys: Array<string> = Object.keys(e);
    const values = Object.values(e);
    const str: string = values.reduce(function (r: string, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`;
      }
      return r;
    }, "");
    getTableData(str, 1);
  }, []);

  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, []);

  const onReset = useCallback(() => {
    form1.resetFields();
    getTableData();
  }, [form1]);

  const handleChange = (e: any, a: any) => {
    console.log("选择结果", e, a);
    console.log("secondLevelList", secondLevelList);
    form2.setFieldsValue({ secondColumn: "" });
    const opt = secondLevelList.filter((el: any) => {
      return el.parentId === e;
    });
    setColumnList(opt);
  };

  const edit = async (e: any) => {
    console.log(e);
    setModalTitle("编辑新闻");
    setEditItem(e);
    const {
      data: { fileList, context, baseNewsType },
    } = await queryNewsInfo(e.id);
    form2.setFieldsValue({
      title: e.title,
      firstColumn: e.firstColumn,
      secondColumn: e.secondColumn,
      baseNewsType: e.baseNewsType,
      context:
        baseNewsType === "CONTENT"
          ? BraftEditor.createEditorState(context)
          : context,
      fileList: fileList.length ? fileList[0].fileUrl : [],
      author: e.author,
      id: e.id,
    });
    setIsContent(baseNewsType === "CONTENT");
    setIsModalOpen(true);
    setFileList(fileList);
    const secondCloumns = await column();
    const opt = secondCloumns.filter((el: any) => {
      return el.parentId === e.firstColumn;
    });
    setColumnList(opt);
  };

  useEffect(() => {
    const opts = columnList.map((e: any) => {
      return (
        <Option value={e.id} key={e.id}>
          {e.name}
        </Option>
      );
    });
    setOptions(opts);
  }, [columnList]);

  const Options1 = firstLevelList.map((e: any) => {
    return (
      <Option value={e.id} key={e.id}>
        {e.name}
      </Option>
    );
  });

  const Options2 = secondLevelList.map((e: any) => {
    return (
      <Option value={e.id} key={e.id}>
        {e.name}
      </Option>
    );
  });

  const addNews = () => {
    setModalTitle("添加新闻");
    setFileList([]);
    setIsModalOpen(true);
  };

  const look = (e: any) => {
    var startTime = new Date().valueOf() / 1000;
    console.log(e);
    let newsList = [
      {
        id: e.id,
        title: e.title,
      },
    ];
    postLeaveAdvertisementTimeMap(newsList, startTime, newsList.length, 2, 2);
    navigate(`/news/details/${e.id}`);
  };

  const del = async (e: any) => {
    console.log(e);
    const { code, msg } = await delEditNews(e.id);
    if (code === 200) {
      message.success(msg);
      getTableData();
    } else {
      message.error(msg);
    }
  };

  const handleOk = async (e: any) => {
    console.log("e", e);
    const { baseNewsType, context } = e;
    submitContent();
    let edit = modalTitle === "编辑新闻" ? true : false;
    const { code, msg } = await addEditNews(
      {
        ...e,
        fileList,
        context: baseNewsType === "CONTENT" ? editorState.toHTML() : context,
      },
      edit
    );
    if (code === 200) {
      message.success(msg);
      setIsModalOpen(false);
      getTableData();
      form2.resetFields();
      setFileList([]);
    } else {
      message.error(msg);
    }
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (newSelectedRowKeys: React.Key[]) => {
  //     setSelectedRowKeys(newSelectedRowKeys);
  //   }
  // };

  const newsTypeChange = (e: any) => {
    form2.setFieldsValue({ context: "" });
    if (e.target.value === "CONTENT") {
      setIsContent(true);
    } else {
      setIsContent(false);
    }
  };
  const onChange = (e: any) => {
    setCurrent(e);
    const keys: Array<string> = Object.keys(form1.getFieldsValue());
    const values = Object.values(form1.getFieldsValue());
    const str: string = values.reduce(function (r: string, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`;
      }
      return r;
    }, "");
    getTableData(str, e);
  };

  const handleCancel = useCallback(() => {
    form2.resetFields();
    // setImgUrl('')
    setIsModalOpen(false);
  }, []);

  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "application/zip" &&
      file.type !== "application/pdf" &&
      file.type !== "application/msword" && // doc文档
      file.type !== "application/vnd.ms-excel" && // XLS表格文件
      file.type !== "application/vnd.ms-powerpoint" && // ppt文档
      file.type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && // DOCX文档文件
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && // XLSX表格文件
      file.type !==
        "application/vnd.openxmlformats-officedocument.presentationml.presentation" && // pptx文件
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    // if (file.size / 1024 / 1024 > 1) {
    //   message.error("上传文件超过1M");
    //   return false;
    // }
    if (fileList.length >= 10) {
      message.error("最多上传10个文件附件");
      return false;
    }
    let formData = new FormData();
    formData.append("file", file);
    console.log("formData--", formData);
    console.log("file--", file);

    // formData.append("uploadFileType", "image");
    // formData.append("folder", "course");

    uploadFileAll(formData).then((res) => {
      console.log("res--", res);
      setFileList([
        ...fileList,
        {
          fileName: file.name,
          shortUrl: res.shortUrl,
        },
      ]);
      console.log("fileList", fileList);

      // form2.setFieldsValue({ fileList: res.shortUrl });
    });
  };
  const submitContent = async () => {
    // Pressing ctrl + s when the editor has focus will execute this method
    // Before the editor content is submitted to the server, you can directly call editorState.toHTML () to get the HTML content
    const htmlContent = editorState.toHTML();
    console.log("htmlContent", htmlContent);
  };

  const handleEditorChange = (editorState: any) => {
    setEditorState(editorState);
    form2.setFieldsValue({
      context: editorState.toHTML(),
    });
  };
  return (
    <div style={{ padding: "15px", background: "#fff" }}>
      <div className="top">
        <Form
          name="newsList"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="新闻标题" name="title">
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item label="发布状态" name="publishStatus">
            <Select placeholder="请选择" allowClear style={{ width: 180 }}>
              <Option value="Y">发布</Option>
              <Option value="N">未发布</Option>
            </Select>
          </Form.Item>

          <Form.Item label="栏目名称" name="secondColumn">
            <Select placeholder="请选择" allowClear style={{ width: 180 }}>
              {Options2}
            </Select>
          </Form.Item>

          <Form.Item style={{ marginLeft: "30px" }}>
            <Button className="searchBtn" type="primary" htmlType="submit">
              <SearchOutlined />
              查询
            </Button>
            <Button
              className="resetBtn"
              type="primary"
              onClick={onReset}
              style={{ marginLeft: "15px" }}
            >
              <RedoOutlined />
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className="midBtn">
        <Button type="primary" onClick={() => addNews()}>
          添加新闻
        </Button>
      </div>

      <div className="tableBottom">
        {/* <Table size='middle' pagination={false} columns={columns} dataSource={data} rowSelection={rowSelection}/> */}
        <Table
          size="middle"
          pagination={false}
          columns={columns}
          dataSource={data}
        />
        <Space
          style={{
            padding: "6px 0",
            justifyContent: "flex-end",
          }}
        >
          <Pagination
            current={current}
            onChange={onChange}
            total={total}
            showSizeChanger={false}
          />
          <span>共{total}条</span>
        </Space>
      </div>

      <Modal
        title={modalTitle}
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        bodyStyle={{ display: "flex", justifyContent: "center" }}
        width={"700px"}
      >
        <Form
          name="addEditNews"
          initialValues={{
            baseNewsType: "CONTENT",
          }}
          onFinish={handleOk}
          autoComplete="off"
          form={form2}
        >
          <Form.Item name="id" hidden>
            <Input placeholder="请输入内容" style={{ width: 380 }} />
          </Form.Item>
          <Form.Item
            label="新闻标题"
            name="title"
            rules={[{ required: true, message: "新闻标题不可为空!" }]}
          >
            <Input
              placeholder="请输入内容"
              style={{ width: 380 }}
              maxLength={100}
            />
          </Form.Item>

          <Form.Item
            label="一级栏目"
            name="firstColumn"
            rules={[{ required: true, message: "内容类型不可为空!" }]}
          >
            <Select
              placeholder="请选择"
              onChange={handleChange}
              allowClear
              style={{ width: 380 }}
            >
              {Options1}
            </Select>
          </Form.Item>
          <Form.Item
            label="二级栏目"
            name="secondColumn"
            rules={[
              { required: Options.length !== 0, message: "内容类型不可为空!" },
            ]}
          >
            <Select
              placeholder="请选择"
              allowClear
              style={{ width: 380 }}
              disabled={Options.length === 0}
            >
              {Options}
            </Select>
          </Form.Item>

          <Form.Item
            label="新闻类型"
            name="baseNewsType"
            rules={[{ required: true, message: "不可为空!" }]}
          >
            <Radio.Group onChange={newsTypeChange}>
              <Radio value="CONTENT">内容</Radio>
              <Radio value="LINK">链接</Radio>
            </Radio.Group>
          </Form.Item>

          <>
            {isContent && (
              <Form.Item
                label="新闻内容"
                name="context"
                rules={[{ required: true, message: "请填写新闻内容!" }]}
              >
                <BraftEditor
                  value={editorState}
                  onChange={handleEditorChange}
                  media={{
                    uploadFn: (param: any) => {
                      let formData = new FormData();
                      formData.append("file", param.file);
                      uploadFileAll(formData).then((res) => {
                        param.success({ url: res.shortUrl });
                      });
                    },
                  }}
                  onSave={submitContent}
                />
              </Form.Item>
            )}
            {!isContent && (
              <Form.Item
                label="新闻链接"
                name="context"
                rules={[{ required: true, message: "请填写新闻内容!" }]}
              >
                <Input />
              </Form.Item>
            )}
            <Form.Item
              label="上传文件"
              name="fileList"
              valuePropName="fileList"
            >
              {fileList.map((item: any, index: number) => (
                <p>
                  {item.fileName}
                  <DeleteOutlined
                    onClick={() => {
                      fileList.splice(index, 1);
                      setFileList([...fileList]);
                    }}
                  />
                </p>
              ))}
              <Upload
                showUploadList={false}
                customRequest={uploadChange}
                maxCount={1}
              >
                <p>* 支持1M以内JPG、PNG、Word、PDF、PPT、Excel、Zip格式文件</p>
                <Button>选择文件</Button>
              </Upload>
            </Form.Item>
          </>
          {/* // ) : (
          //   <>
          //     <Form.Item
          //       label="链接地址"
          //       name="context"
          //       rules={[{ required: true, message: "链接地址不可为空!" }]}
          //     >
          //       <Input placeholder="请输入内容" style={{ width: 180 }} />
          //     </Form.Item>
          //   </>
          // )} */}

          <Form.Item
            label="作者署名"
            name="author"
            rules={[{ required: true, message: "作者署名不可为空!" }]}
          >
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button onClick={handleCancel} style={{ marginRight: "15px" }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default Index;
